// Action Types
export const Types = {
  CONTACT_CREATE:'CONTACT_CREATE',
  CONTACT_CREATE_SUCESS: 'CONTACT_CREATE_SUCESS',
  CONTACT_CREATE_ERROR: 'CONTACT_CREATE_ERROR',
  CONTACT_UPDATE:'CONTACT_UPDATE',
  CONTACT_UPDATE_SUCESS: 'CONTACT_UPDATE_SUCESS',
  CONTACT_UPDATE_ERROR: 'CONTACT_UPDATE_ERROR',
  CONTACT_LIST:'CONTACT_LIST',
  CONTACT_LIST_ERROR:'CONTACT_LIST_ERROR',
  CONTACT_LIST_SUCESS: 'CONTACT_LIST_SUCESS',
  CONTACT_LIST_SUCESS_PAGINATED: 'CONTACT_LIST_SUCESS_PAGINATED',
  CONTACT_DELETE:'CONTACT_DELETE',
  CONTACT_DELETE_SUCESS: 'CONTACT_DELETE_SUCESS',
  CONTACT_DELETE_ERROR: 'CONTACT_DELETE_ERROR',
  CONTACT_FIND_BY_ID:'CONTACT_FIND_BY_ID',
  CONTACT_FIND_BY_COMPANY_ID_PAGINATED:'CONTACT_FIND_BY_COMPANY_ID_PAGINATED',
  UPDATE_IS_LOADING:'UPDATE_IS_LOADING',
  CONTACT_FIND_BY_ID_SUCCESS:'CONTACT_FIND_BY_ID_SUCCESS',
  CONTACT_FIND_BY_ID_ERROR:'CONTACT_FIND_BY_ID_ERROR',
}

// Reducer
const INITIAL_STATE = {
  contact: {},
  contacts: [],
  pagination: {
    totalItems: 0,
    totalPages: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  isLoading: false,
  isUpToDate: false,
}

export default function reducer(state = INITIAL_STATE, action) {

  switch (action.type) {

    case Types.CONTACT_LIST_SUCESS: {
      return {
        ...state,
        contact: action.payload
      }
    }
    case Types.CONTACT_LIST_SUCESS_PAGINATED: {
      return {
        ...state,
        contacts: action.payload.contacts,
        pagination: action.payload.pagination,
        isUpToDate: true
      }
    }
    case Types.CONTACT_FIND_BY_ID_SUCCESS: {
      return {
        ...state,
        contacts:action.payload,
        isUpToDate: true
      }
    }

    case Types.CONTACT_CREATE: {
      return{
        ...state,
        contact: action.payload
      }
    }

    case Types.CONTACT_CREATE_SUCESS: {
      return {
        ...state,
        contact: action.payload,
        isUpToDate: false
      }
    }

    case Types.CONTACT_UPDATE: {
      return {
        ...state,
        id: action.id,
        contact: action.payload
      }
    }

    case Types.CONTACT_UPDATE_SUCESS: {
      return {
        ...state,
        id: action.id,
        contact: action.payload,
        isUpToDate: false
      }
    }

    case Types.CONTACT_DELETE: {
      return {
        ...state,
        id: action.id
      }
    }

    case Types.CONTACT_DELETE_SUCESS: {
      return {
        ...state,
        id: action.id,
        isUpToDate: false
      }
    }

    case Types.UPDATE_IS_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      }
    }

    default:
      return state;
  }

}

// Action Creators
export const createContact = (contact) => {
  return {
      type: Types.CONTACT_CREATE,
      payload: contact
  };
};

export const createContactSucess = (contact) => {
  return{
    type: Types.CONTACT_CREATE_SUCESS,
    payload: contact
  }
}


export const updateContact = (id, contact) => {
  return {
      type: Types.CONTACT_UPDATE,
      id: id,
      payload: contact
  };
};

export const updateContactSuccess = (id, contact) => {
  return {
      type: Types.CONTACT_UPDATE_SUCESS,
      id: id,
      payload: contact
  };
};

export const deleteContact = (id) => {
  return {
    type: Types.CONTACT_DELETE,
    id: id
  };
};
export const deleteContactSuccess = (id) => {
  return {
    type: Types.CONTACT_DELETE_SUCESS,
    id: id
  };
};

export const contactList = (id) => {
  return {
    type: Types.CONTACT_FIND_BY_ID,
    payload: id
  }
}

export const contactListByCompanyIdPaginated = (companyId, page, limit, sort, order) => {
  return {
    type: Types.CONTACT_FIND_BY_COMPANY_ID_PAGINATED,
    payload: { companyId, page, limit, sort, order }
  }
}

export const updateIsLoading = (isLoading) => {
  return {
    type: Types.UPDATE_IS_LOADING,
    payload: isLoading
  }
}

export const findByIdSuccess = (contact) => {
  return {
    type: Types.CONTACT_FIND_BY_ID_SUCCESS,
    payload: contact
  }
}

export const listByCompanyIdSuccess = (contacts, pagination) => {
  return {
    type: Types.CONTACT_LIST_SUCESS_PAGINATED,
    payload: { contacts, pagination }
  }
}
